export default __webpack_public_path__ + "static/media/whitelist.a19da876.png";